import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessageService, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { AlertComponent } from './alert/alert.component';
import { AlertTimerComponent } from './alert-timer/alert-timer.component';
import { DialogComponent } from './dialog/dialog.component';
import { InformationComponent } from './information/information.component';
import { MessageComponent } from './message/message.component';

import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    AlertComponent,
    AlertTimerComponent,
    DialogComponent,
    InformationComponent,
    MessageComponent
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    SharedModule,
    ToastModule,
    ConfirmDialogModule,
    ButtonModule
  ],
  exports: [
    AlertComponent,
    AlertTimerComponent,
    DialogComponent,
    InformationComponent,
    MessageComponent
  ],
  providers: [
    MessageService,
    ConfirmationService
  ]
})
export class MessagesModule { }
